// extracted by mini-css-extract-plugin
export var centerText = "_hg-8";
export var container = "_hg-0";
export var doughnutContainer = "_hg-7";
export var legend = "_hg-a";
export var legendItemColorDisplay = "_hg-b";
export var legendItemLabel = "_hg-d";
export var legendItemValue = "_hg-c";
export var lg = "_hg-5";
export var maxWidth = "_hg-9";
export var md = "_hg-4";
export var responsive = "_hg-6";
export var sm = "_hg-3";
export var xs = "_hg-2";
export var xxs = "_hg-1";